module.exports = __webpack_public_path__ + "static/media/quantum.4ef19554.png";